<template>
   <v-container>
      <!-- Title Banner -->
      <v-row>
         <v-col cols="12" md="12">
            <v-toolbar dense color="primary white--text" bottom>
               <v-toolbar-title v-if="$vuetify.breakpoint.mdAndUp">
                  Manage User
               </v-toolbar-title>
               <v-icon color="white" v-else>mdi-account-group</v-icon>
            </v-toolbar>
            <v-toolbar>
               <v-btn class="ma-2" small outlined color="indigo" @click="createUser()">
                  <v-icon left>mdi-plus</v-icon>
                  <div v-if="$vuetify.breakpoint.mdAndUp">Create</div>
               </v-btn>
            </v-toolbar>
         </v-col>
      </v-row>
      <v-row no-gutters>
         <v-col md="12">
            <v-card class="overflow-y-auto">
               <v-card-title>
                  <v-text-field
                     v-model="searchTerm"
                     append-icon="mdi-magnify"
                     label="Search"
                     single-line
                     hide-details
                     @input="waitForSearchTerm"
                     clearable
                  ></v-text-field>
               </v-card-title>
               <v-data-table
                  dense
                  :headers="usertable_headers"
                  :items="userlist"
                  item-key="id"
                  single-select
                  :options.sync="paginateOptions"
                  :server-items-length="userCount"
                  :footer-props="rowCountOptions"
                  @update:page="pageChange"
                  @update:sort-by="sortChange"
                  @update:sort-desc="sortChange"
                  @update:items-per-page="rowCountChange"
                  @click:row="userRowClick"
               >
                  <!-- eslint-disable-next-line -->
                  <template v-slot:item.status="{item}">
                     {{ item.status == 1 ? "Enabled" : "Disabled" }}
                  </template>
                  <!-- eslint-disable-next-line -->
                  <template v-slot:item.actions="{item}">
                     <v-icon small class="mr-2" @click="editUser(item)">
                        mdi-pencil
                     </v-icon>
                  </template>
               </v-data-table>
            </v-card>
         </v-col>
      </v-row>
   </v-container>
</template>

<script>
   import _ from "lodash";

   export default {
      inject: ["ShowMessage"],

      data() {
         return {
            searchTerm: "",
            userlist: [],
            userCount: 0,
            currentPage: null,
            paginateOptions: {},
            rowCountOptions: {
               "items-per-page-options": [5, 10, 15],
            },
            paginate: {
               lastid: this.$globalstore.usermanager.lastid || null,
               firstid: this.$globalstore.usermanager.firstid || null,
               rowcount: this.$globalstore.usermanager.rowcount || 10,
               sortby: this.$globalstore.usermanager.sortby || "user_name",
               sortdesc: this.$globalstore.usermanager.sortdirection || false,
            },
            pagingItemList: [5, 10, 15],
            usertable_headers: [
               {
                  text: "ID",
                  value: "id",
                  width: "10%",
                  sortable: false,
                  class: this.$globalstore.table_headerclass,
               },
               {
                  text: "Name",
                  value: "user_name",
                  width: "35%",
                  sortable: true,
                  class: this.$globalstore.table_headerclass,
               },
               {
                  text: "Email",
                  value: "user_email",
                  width: "25%",
                  sortable: true,
                  class: this.$globalstore.table_headerclass,
               },
               {
                  text: "User Type",
                  value: "usertypetext",
                  width: "15%",
                  sortable: false,
                  class: this.$globalstore.table_headerclass,
               },
               {
                  text: "Status",
                  value: "userstatustext",
                  width: "15%",
                  sortable: false,
                  class: this.$globalstore.table_headerclass,
               },
               {
                  text: "",
                  value: "actions",
                  width: "15%",
                  sortable: false,
                  class: this.$globalstore.table_headerclass,
               },
            ],
         };
      },

      methods: {
         userRowClick(item, row) {
            row.select(!row.isSelected);
         },

         waitForSearchTerm: _.debounce(function(e) {
            this.paginate.lastid = null;
            this.paginate.firstid = null;
            this.paginate.sortby = this.paginateOptions.sortBy[0] || "user_name";
            this.paginate.sortdesc = this.paginateOptions.sortDesc[0] || false;
            this.loadUserCount();
            this.retrieveUserList();
         }, 500),

         savePaginateOptions() {
            this.$globalstore.usermanager.page = this.paginateOptions.page;
            this.$globalstore.usermanager.rowcount = this.paginateOptions.itemsPerPage;
            this.$globalstore.usermanager.sortby = this.paginateOptions.sortBy[0];
            this.$globalstore.usermanager.sortdesc = this.paginateOptions.sortDesc[0];
            this.$globalstore.usermanager.searchterm = this.searchTerm;
         },

         pageChange(page) {
            if (this.currentPage) {
               if (page > this.currentPage) {
                  this.paginate.firstid = "";
                  if (this.paginate.sortby == "user_name") {
                     this.paginate.lastid = this.userlist[this.userlist.length - 1].user_name;
                  } else if (this.paginate.sortby == "user_email") {
                     this.paginate.lastid = this.userlist[this.userlist.length - 1].user_email;
                  }
               } else if (page < this.currentPage) {
                  this.paginate.lastid = "";
                  if (this.paginate.sortby == "user_name") {
                     this.paginate.firstid = this.userlist[0].user_name;
                  } else if (this.paginate.sortby == "user_email") {
                     this.paginate.lastid = this.userlist[0].user_email;
                  }
               } else {
                  // page == currentpage
                  this.paginate.lastid = this.$globalstore.usermanager.lastid;
                  this.paginate.firstid = this.$globalstore.usermanager.firstid;
                  this.paginate.sortby = this.$globalstore.usermanager.sortby;
                  this.paginate.sortdesc = this.$globalstore.usermanager.sortdesc;
                  this.paginateOptions.page = this.$globalstore.usermanager.page;
               }

               this.retrieveUserList();

               this.$globalstore.usermanager.firstid = this.paginate.firstid;
               this.$globalstore.usermanager.lastid = this.paginate.lastid;
               this.$globalstore.usermanager.page = page;
               this.currentPage = page;
            }
         },

         sortChange() {
            if (this.paginateOptions.sortBy[0]) {
               this.paginate.sortby = this.paginateOptions.sortBy[0];
            } else {
               this.paginate.sortby = "user_name";
            }

            if (this.paginateOptions.sortDesc[0]) {
               this.paginate.sortdesc = this.paginateOptions.sortDesc[0];
            } else {
               this.paginate.sortdesc = false;
            }

            this.paginate.firstid = null;
            this.paginate.lastid = null;
            this.$globalstore.usermanager.firstid = null;
            this.$globalstore.usermanager.lastid = null;
            this.currentPage = 1;

            this.userlist = [];
            this.retrieveUserList();
         },

         rowCountChange() {
            this.$globalstore.usermanager.rowcount = this.paginateOptions.itemsPerPage;
            this.paginate.lastid = null;
            this.paginate.firstid = null;
            this.$globalstore.usermanager.firstid = null;
            this.$globalstore.usermanager.lastid = null;
            this.paginate.rowcount = this.paginateOptions.itemsPerPage;
            this.currentPage = 1;

            this.userlist = [];
            this.retrieveUserList();
         },

         async retrieveUserList() {
            await this.$http({
               url: "/common/getuserlist.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  searchterm: this.searchTerm,
                  pagination: this.paginate,
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (!response.data.error) {
                  this.userlist = response.data.userdata;
               } else {
                  this.userlist = [];
               }
            });
         },

         createUser() {
            this.$router.push({name: "AddUser"});
         },

         editUser(item) {
            this.savePaginateOptions();

            this.$router.push({
               name: "EditUser",
               params: {userid: item.id},
            });
         },

         async loadUserCount() {
            await this.$http({
               url: "/common/getusercount.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  searchterm: this.searchTerm,
                  sortby: this.paginate.sortby,
                  userid: this.$globalstore.user.userid,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.error) {
                  this.ShowMessage({
                     title: "Error",
                     message: response.data.message,
                     color: "red",
                  });
               } else {
                  var numofusers = response.data.usercount;
                  this.userCount = parseInt(numofusers);
               }
            });
         },
      },

      async mounted() {
         this.loadUserCount();

         if (this.$globalstore.usermanager.page && this.$globalstore.usermanager.page > 1) {
            this.paginateOptions.page = this.$globalstore.usermanager.page;
            this.paginateOptions.itemsPerPage = this.$globalstore.usermanager.rowcount;
            this.paginateOptions.sortBy[0] = this.$globalstore.usermanager.sortby || "user_name";
            this.paginateOptions.sortDesc[0] = this.$globalstore.usermanager.sortdesc || false;

            this.paginate.firstid = this.$globalstore.usermanager.firstid;
            this.paginate.lastid = this.$globalstore.usermanager.lastid;
            this.paginate.rowcount = this.$globalstore.usermanager.rowcount;
            this.paginate.sortby = this.$globalstore.usermanager.sortby || "user_name";
            this.paginate.sortdesc = this.$globalstore.usermanager.sortdesc || false;
            this.currentPage = this.$globalstore.usermanager.page;
            if (this.$globalstore.usermanager.searchterm) {
               this.searchTerm = this.$globalstore.usermanager.searchterm;
               this.retrieveUserList();
            }
         } else {
            this.currentPage = 1;
            this.retrieveUserList();
            this.paginateOptions.sortBy[0] = "user_name";
            this.paginateOptions.sortDesc[0] = false;
         }
      },
   };
</script>
